var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "singleerr" },
    _vm._l(_vm.group, function (item, index) {
      return _c("div", { key: index, staticClass: "list_box" }, [
        _c("div", { staticClass: "_row" }, [
          _c("div", { staticClass: "strIcon" }, [
            _vm._v(_vm._s(_vm.setNumberToLetter(index + 1))),
          ]),
          _c(
            "div",
            [
              _c("form_select", {
                ref: "form",
                refInFor: true,
                staticClass: "select",
                attrs: {
                  options: _vm.eventOptions,
                  placeholder: "请选择事件表",
                },
                on: {
                  change: () => {
                    item.attrsList = _vm.eventOptions.filter(
                      (_item) => _item.value == item.theme
                    )[0].chidlren
                    item.service_typeOptions = item.attrsList.filter(
                      (_item) => _item.label == "service_type"
                    )[0].children
                    item.service_numberOptions = item.attrsList.filter(
                      (_item) => _item.value == "service_number"
                    )[0].children
                    // item.attrs[0].val = []
                    // item.attrs[1].val = []
                    item.attrs.forEach((_item, _index) => {
                      _item.val = []
                      if (_index > 1) {
                        _item.attr = ""
                      }
                    })
                  },
                },
                model: {
                  value: item.theme,
                  callback: function ($$v) {
                    _vm.$set(item, "theme", $$v)
                  },
                  expression: "item.theme",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("form_select", {
                ref: "form",
                refInFor: true,
                staticClass: "select",
                attrs: {
                  disabled: item.theme == "",
                  multiple: true,
                  isRules: false,
                  options: item.service_typeOptions || [],
                  placeholder: "请选择service_type",
                },
                model: {
                  value: item.attrs[0].val,
                  callback: function ($$v) {
                    _vm.$set(item.attrs[0], "val", $$v)
                  },
                  expression: "item.attrs[0].val",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("form_select", {
                ref: "form",
                refInFor: true,
                staticClass: "select",
                staticStyle: { width: "300px" },
                attrs: {
                  disabled: item.theme == "",
                  multiple: true,
                  isRules: false,
                  options: item.service_numberOptions || [],
                  placeholder: "请选择service_number",
                },
                model: {
                  value: item.attrs[1].val,
                  callback: function ($$v) {
                    _vm.$set(item.attrs[1], "val", $$v)
                  },
                  expression: "item.attrs[1].val",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "inline-block" } },
            [
              _c(
                "el-tooltip",
                { attrs: { content: "添加条件", placement: "top" } },
                [
                  _c("el-button", {
                    staticStyle: { "margin-left": "12px" },
                    attrs: { type: "text", icon: "el-icon-zoom-in" },
                    on: {
                      click: function ($event) {
                        return item.attrs.push({
                          //属性行
                          attr: "",
                          valid: "",
                          opt: "",
                          val: [], // 多选
                        })
                      },
                    },
                  }),
                ],
                1
              ),
              index != 0
                ? _c(
                    "el-tooltip",
                    { attrs: { content: "删除", placement: "top" } },
                    [
                      _c("el-button", {
                        staticStyle: { "margin-left": "12px" },
                        attrs: { type: "text", icon: "el-icon-delete" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteRow(_vm.group, index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.group.push({
                        name: "A",
                        theme: "", //事件表
                        attr_logic: "AND",
                        attrs: [
                          {
                            // service_type
                            attr: "service_type",
                            opt: "in",
                            val: [], // 多选
                          },
                          {
                            //service_number
                            attr: "service_number",
                            opt: "in",
                            val: [], // 多选
                          },
                          {
                            //属性行
                            attr: "",
                            valid: "",
                            opt: "",
                            val: [], // 多选
                          },
                        ],
                      })
                    },
                  },
                },
                [_vm._v("添加事件")]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "_row_item" }, [
          _c(
            "div",
            {
              staticClass: "andOrIcon",
              on: {
                click: () => {
                  item.attr_logic = item.attr_logic == "AND" ? "OR" : "AND"
                },
              },
            },
            [_vm._v(_vm._s(item.attr_logic) + "\n      ")]
          ),
          _c(
            "div",
            { staticClass: "_row_item_box" },
            _vm._l([...item.attrs.slice(2)], function (attrsItem, attrsIndex) {
              return _c("div", { key: attrsIndex, staticClass: "_row_box" }, [
                _c(
                  "div",
                  [
                    _c("form_select", {
                      ref: "form",
                      refInFor: true,
                      staticClass: "select",
                      attrs: {
                        disabled: item.theme == "",
                        options: item.attrsList || [],
                        placeholder: "请输入属性",
                      },
                      on: {
                        change: () => {
                          item.attrs[2 + attrsIndex].valid = ""
                          item.attrs[2 + attrsIndex].val = []
                          item.attrs[2 + attrsIndex].valOptions =
                            item.attrsList.filter(
                              (_item) =>
                                _item.value == item.attrs[2 + attrsIndex].attr
                            )[0].children
                        },
                      },
                      model: {
                        value: item.attrs[2 + attrsIndex].attr,
                        callback: function ($$v) {
                          _vm.$set(item.attrs[2 + attrsIndex], "attr", $$v)
                        },
                        expression: "item.attrs[2+attrsIndex].attr",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("form_select", {
                      ref: "form",
                      refInFor: true,
                      staticClass: "select",
                      attrs: {
                        disabled: item.attrs[2 + attrsIndex].attr == "",
                        options: _vm.validOptions || [],
                        placeholder: "请选择口径",
                      },
                      on: {
                        change: () => {
                          let obj =
                            _vm.validOptions.filter(
                              (_item) =>
                                _item.value == item.attrs[2 + attrsIndex].valid
                            )[0] || {}
                          item.attrs[2 + attrsIndex].val = []
                          if (obj.children) {
                            item.attrs[2 + attrsIndex].valOptions = obj.children
                          } else {
                            item.attrs[2 + attrsIndex].valOptions =
                              item.attrsList.filter(
                                (_item) =>
                                  _item.value == item.attrs[2 + attrsIndex].attr
                              )[0].children
                          }
                        },
                      },
                      model: {
                        value: item.attrs[2 + attrsIndex].valid,
                        callback: function ($$v) {
                          _vm.$set(item.attrs[2 + attrsIndex], "valid", $$v)
                        },
                        expression: "item.attrs[2+attrsIndex].valid",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("form_select", {
                      ref: "form",
                      refInFor: true,
                      staticClass: "select",
                      attrs: {
                        options: _vm.optOptions || [],
                        placeholder: "请选择判断",
                      },
                      model: {
                        value: item.attrs[2 + attrsIndex].opt,
                        callback: function ($$v) {
                          _vm.$set(item.attrs[2 + attrsIndex], "opt", $$v)
                        },
                        expression: "item.attrs[2+attrsIndex].opt",
                      },
                    }),
                  ],
                  1
                ),
                item.attrs[2 + attrsIndex].opt != "非空" &&
                item.attrs[2 + attrsIndex].opt != "为空"
                  ? _c(
                      "div",
                      [
                        _c("form_select", {
                          ref: "form",
                          refInFor: true,
                          staticClass: "select",
                          attrs: {
                            disabled: item.attrs[2 + attrsIndex].attr == "",
                            multiple: true,
                            options:
                              item.attrs[2 + attrsIndex].valOptions || [],
                            placeholder: "请输入结果",
                          },
                          model: {
                            value: item.attrs[2 + attrsIndex].val,
                            callback: function ($$v) {
                              _vm.$set(item.attrs[2 + attrsIndex], "val", $$v)
                            },
                            expression: "item.attrs[2+attrsIndex].val",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { content: "删除", placement: "top" } },
                      [
                        _c("el-button", {
                          staticStyle: { "margin-left": "12px" },
                          attrs: { type: "text", icon: "el-icon-delete" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteRow(
                                _vm.group[index].attrs,
                                attrsIndex + 2
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            }),
            0
          ),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }